import { motion } from "motion/react";

function MAPGraph({ activeStep, stepId }: { activeStep: number; stepId: number }) {
  return (
    <>
      <motion.path
        d="M12 270C12 270 51 227 51 154H339"
        stroke="url(#paint_map)"
        strokeWidth="24"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial="hidden"
        variants={{
          show: {
            pathLength: [0.001, 1],
            pathOffset: [0.0001],
            opacity: 1,
            transition: { duration: 2, ease: [0.25, 0.1, 0.25, 1] },
          },
          hidden: {
            pathLength: [1, 0.001],
            pathOffset: [0.0001, 0.9999],
            opacity: 0,
            transition: { pathLength: { opacity: 0.2 } },
          },
        }}
        animate={activeStep === stepId ? "show" : "hidden"}
      />
      <defs>
        <linearGradient
          id="paint_map"
          x1="175"
          y1="270"
          x2="175"
          y2="154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEF39B" />
          <stop offset="1" stopColor="#FECF12" />
        </linearGradient>
      </defs>
    </>
  );
}

export default MAPGraph;
